export const formatVoucherQuantity = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return value == null ? '0' : String(value);
  }
  if (Number.isInteger(parsed)) {
    return String(parsed);
  }
  return String(value);
};

export const normalizeReceiptLabel = (value) => {
  if (value === undefined || value === null) return '';
  return String(value).trim();
};

export const stripVarietyPrefix = (productName, varietyName) => {
  const productLabel = normalizeReceiptLabel(productName);
  const varietyLabel = normalizeReceiptLabel(varietyName);
  if (!productLabel || !varietyLabel) return varietyLabel;
  const productLower = productLabel.toLowerCase();
  const varietyLower = varietyLabel.toLowerCase();
  if (!varietyLower.startsWith(productLower)) return varietyLabel;
  let stripped = varietyLabel.slice(productLabel.length).trim();
  stripped = stripped.replace(/^[-–—:|/]+\s*/, '');
  return stripped || varietyLabel;
};

export const buildReceiptItemDisplayName = (item) => {
  const productName = normalizeReceiptLabel(item?.productName);
  const varietyName = normalizeReceiptLabel(item?.varietyName);
  if (productName && varietyName) {
    const strippedVariety = stripVarietyPrefix(productName, varietyName);
    if (!strippedVariety || strippedVariety.toLowerCase() === productName.toLowerCase()) {
      return productName;
    }
    return `${productName} - ${strippedVariety}`;
  }
  return productName || varietyName || 'Producto';
};

export const buildReceiptItemLine = ({ item, unitPrice, quantityLabel }) => {
  const displayName = buildReceiptItemDisplayName(item);
  const metricUnit = normalizeReceiptLabel(item?.metricUnit) || 'unidad';
  const priceText = Number(unitPrice || 0).toLocaleString('de-DE');
  return `${displayName} ${metricUnit} (${priceText} x ${quantityLabel})`;
};

export const formatReceiptMoney = (value) => {
  const amount = Number(value || 0);
  if (!Number.isFinite(amount)) return '0';
  return amount.toLocaleString('de-DE');
};
